export const enum MyAccountSortOptionEnum {
  saveDate = '-save_date',
  lowPrice = 'price',
  highPrice = '-price',
  recent = 'recent',
  contactDate = '-contact_date',
  modifiedDate = '-modified_date',
}
